module.exports = "/static/assets/9b72c9b4439a7f1c690add6b45c51360.png";